// Hand-curated schedule. Each event ID maps to a decimal hour of day
// (9.5 = 9:30 AM, 13.25 = 1:15 PM). Indexed by 1-based day number so that
// events sharing an ID across days (e.g. "sunrise" on Day 1 and Day 8) can
// each have their own time. Firestore's event.start values were not
// reliable; these replace them entirely.
//
// Edit freely — rebuild is not needed to change these times, just save.

export const EVENT_TIMES: Record<number, Record<string, number>> = {
  1: {
    firstlesson: 9,               // 9:00 AM  Introduction
    mainprintstrings: 9.3333,      // 9:20 AM  Print and more!
    'print-something': 9.4167,     // 9:25 AM  Print Something
    lesson2: 9.5833,               // 9:35 AM  Input and more!
    agreementbot: 10,              // 10:00 AM  Agreement Bot
    sunrise: 10.1667,              // 10:10 AM  Mad Libs (Day 1 uses id "sunrise")
    lesson3: 10.25,                // 10:15 AM  call_gpt()
    'ai-haiku': 10.4167,           // 10:25 AM  Haiku
    songrecommender: 10.5833,      // 10:35 AM  Song Recommender
    lesson4: 10.9167,              // 10:55 AM  Numbers
    dogyears: 11.5,                // 11:30 AM  Dog Years
    carbondating: 11.6667,         // 11:40 AM  Carbon Dating
    treasureconversion: 11.8333,   // 11:50 AM  Treasure Conversion
    booleanandconditionals: 12,    // 12:00 PM  Booleans and Conditionals
    booleanandconditionalshandout: 12.25,  // 12:15 PM  Handout
    lunch1: 12.5,                  // 12:30 PM  Lunch
    lesson5: 13.5,                 // 1:30 PM  While Loops
    doubleit: 13.6667,             // 1:40 PM  Double It
    'random-libraries': 14,        // 2:00 PM  Random and Libraries
    hailstone: 14.1667,            // 2:10 PM  Hailstone
    guessmynumber: 14.75,          // 2:45 PM  Guess My Number
    khansole: 15.5,                // 3:30 PM  Khansole Academy
    whoami: 16.25,                 // 4:15 PM  Guess Who Am I
    gameofnimm: 17,                // 5:00 PM  Game of Nimm (Optional)
  },

  2: {
    day1reviewhandout: 9,          // 9:00 AM  Day 1 Review
    lists: 9.3333,                 // 9:20 AM  Lists
    listshandout: 9.5,             // 9:30 AM  Lists Handout
    forloops: 9.75,                // 9:45 AM  For Loops
    'for-loops-handout': 10,       // 10:00 AM  For Loops Handout
    double_list: 10.25,            // 10:15 AM  Double List
    counteven: 10.4167,            // 10:25 AM  Count Even
    strings: 10.6667,              // 10:40 AM  Strings
    'count-chars': 11,             // 11:00 AM  Count Characters
    'ascii-pyramid': 11.75,        // 11:45 AM  ASCII Pyramid (Optional)
    'caesar-cipher-encoder': 11.9167,  // 11:55 AM  Caesar Cipher (Encoder)
    lunch2: 12.5,                  // 12:30 PM  Lunch
    crispr: 13.5,                  // 1:30 PM  CRISPR (Optional)
    wordleintroduction: 14,        // 2:00 PM  Wordle Introduction
    wordle: 14.25,                 // 2:15 PM  Wordle
  },

  3: {
    functionslesson: 9,            // 9:00 AM  Functions Lesson
    functionshandout: 9.5,         // 9:30 AM  Functions Handout
    codingbat: 9.75,               // 9:45 AM  Codingbat
    lunch3: 12.5,                  // 12:30 PM  Lunch
    graphicslesson: 13.5,          // 1:30 PM  Graphics
    decomposition: 13.75,          // 1:45 PM  Scene with Functions
    dictionarieslesson: 14,        // 2:00 PM  Dictionaries
    quizzlet: 14.25,               // 2:15 PM  Quizzlet
    'count-numbers': 14.5,         // 2:30 PM  Count Numbers
    phonebook: 14.75,              // 2:45 PM  Phonebook
    'caesar-cipher-decode': 15,    // 3:00 PM  Caesar Cipher (decoder)
  },

  4: {
    environmentlesson: 9,          // 9:00 AM  Environment
    fileparsinglesson: 9.5,        // 9:30 AM  File Parsing
    'print-every-line': 9.75,      // 9:45 AM  Print Every Line
    computeaverage: 10,            // 10:00 AM  Compute Average
    'clean-notes': 10.25,          // 10:15 AM  Clean Notes
    'like-counter': 10.5,          // 10:30 AM  Like Counter
    'off-the-record': 10.75,       // 10:45 AM  Off the Record
    fedPapers: 11,                 // 11:00 AM  Federalist Papers (90 min)
    lunch4: 12.5,                  // 12:30 PM  Lunch
    jsonlesson: 13.5,              // 1:30 PM  JSON
    'my-first-json': 13.75,        // 1:45 PM  My First JSON
    'a-thesaurus': 14.25,          // 2:15 PM  A Thesaurus
    towers: 15,                    // 3:00 PM  Towers (2-hour capstone)
  },

  5: {
    infinitestorylesson: 9.5,      // 9:30 AM  OpenAI and Infinite Story Lesson
    infinitestory: 9.8333,         // 9:50 AM  Infinite Story (2 hours)
    csvandpandas: 11.8333,         // 11:50 AM  CSV and pandas
    'titanic-survival': 12,        // 12:00 PM  Titanic Survival
    'introvert-extrovert': 12.25,  // 12:15 PM  Introvert Extrovert
    lunch5: 12.5,                  // 12:30 PM  Lunch
  },

  6: {
    'pandas-cont': 9.3333,         // 9:20 AM  Pandas Continued
    netflix: 9.5,                  // 9:30 AM  Netflix
    mta: 9.75,                     // 9:45 AM  MTA Ridership
    matching_travelers: 10.25,     // 10:15 AM  Matching Travelers
    'matplotlib-excersize': 11.5,  // 11:30 AM  Matplotlib
    spurious_correlations: 11.8333,  // 11:50 AM  Spurious Correlations
    'plot-square': 12.1667,        // 12:10 PM  Plot Square
    temperature: 13.5,             // 1:30 PM  Temperature
    'romeo-vs-juliet': 13.8333,    // 1:50 PM  Romeo Vs Juliet
    'church-law-term-analysis': 14.5,  // 2:30 PM  Church Law
  },

  7: {
    openailesson2: 9.25,           // 9:15 AM  OpenAI API (revisited)
    'pirate-translator': 9.5,      // 9:30 AM  Pirate Translator
    'only-good-news': 9.8333,      // 9:50 AM  Only Good News
    'continuous-convo': 11.4167,   // 11:25 AM  Continuous Convo
    'transcribe-this': 11.5,       // 11:30 AM  Transcribe This
    'continue-the-story': 11.75,   // 11:45 AM  Continue the Story
    'where-am-i': 12.4167,         // 12:25 PM  Where Am I
    lunch7: 12.5,                  // 12:30 PM  Lunch
    'sentiment-analysis': 13.5,    // 1:30 PM  Sentiment Analysis
    llms: 14.5,                    // 2:30 PM  How LLMs work (with Teddi Worledge)
  },

  8: {
    requestslesson: 9,             // 9:00 AM  Requests Lesson
    iss: 9.5,                      // 9:30 AM  ISS
    'sound-techy': 9.8333,         // 9:50 AM  Sound Techy
    sunrise: 10.25,                // 10:15 AM  Sunrise (Day 8 uses same id "sunrise")
    'poetry-search': 10.75,        // 10:45 AM  Poetry
    apod: 11.25,                   // 11:15 AM  Astronomy Picture of the Day
    'cfh-api': 11.75,              // 11:45 AM  Code for Humanities
    lunch8: 12.5,                  // 12:30 PM  Lunch
    numpylesson: 13.5,             // 1:30 PM  numpy lesson
    wine: 13.75,                   // 1:45 PM  Wine
    heartdisease: 14.5,            // 2:30 PM  Heart
    'numpy-2-slides': 15,          // 3:00 PM  Numpy (Continued, part 2)
    sap4000: 15.25,                // 3:15 PM  Exam Scores
  },

  9: {
    github: 9,                     // 9:00 AM  Github
    'helper-files': 9.5,           // 9:30 AM  Multi-Files Programs
    day9repo: 9.75,                // 9:45 AM  Day 9 Assignments Repo
    'simply-graphs': 10,           // 10:00 AM  Simply Graphs
    classes: 11,                   // 11:00 AM  Classs (data structure)
    historical_figure: 11.5,       // 11:30 AM  Historical Figure
    'optimized-textfile-class': 13.5,  // 1:30 PM  Optimized Text File (90 min)
    'jp-nb': 15,                   // 3:00 PM  Jupyter Notebook
    'my-first-jupyter-nb': 15.25,  // 3:15 PM  My First Jupyter Notebook
    'small-but-mighty': 16,        // 4:00 PM  Small but Mighty Python Concepts
    rapidfire: 16.25,              // 4:15 PM  Rapidfire
    'fake-news': 16.5833,          // 4:35 PM  Fake News
  },

  10: {
    day10: 9,                      // 9:00 AM  Day 10 Repository
    'intro-day-10': 9,             // 9:00 AM  Intro Day 10 (shown alongside repo)
    selenium: 9.25,                // 9:15 AM  Selenium (Web Scraping)
    screenshot: 9.75,              // 9:45 AM  Screenshot
    'click-button': 10.25,         // 10:15 AM  Click Button
    'scrape-our-site': 10.75,      // 10:45 AM  Scrape our site
    'nasa-pics': 11.5,             // 11:30 AM  NASA Pictures
  },
};
